import httpService from '../../http'
import api from '../../api'
import helpers from '../../helpers'

const errorsStr = helpers.error.errors
const mapper = helpers.mapper
const apiModule = api.kontrollers

function getModel () {
  return {
    // pstatus
    KID: {
      data: 'KID',
      title: 'ID',
      value: null,
      type: null,
      order: 'desc',
      showOrder: true
    },
    BASUM: {
      data: 'BASUM',
      title: 'Текущая сумма бумажных денег',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    BAKUP: {
      data: 'BAKUP',
      title: 'Количество принятых купюр',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    BAS: {
      data: 'BAS',
      title: 'Текущее состояние купюроприёмника',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    BAPP: {
      data: 'BAPP',
      title: 'Процент приёма купюр',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    USSD: {
      data: 'USSD',
      title: 'Остаток денег на СИМ карте',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    GSMSL: {
      data: 'GSMSL',
      title: 'Уровень сигнала GSM',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    FWVER: {
      data: 'FWVER',
      title: 'Версия прошивки',
      value: null,
      type: 'ver',
      order: null,
      showOrder: true
    },
    KK: {
      data: 'KK',
      title: 'KK',
      value: null,
      type: null
    },
    K1S: {
      data: 'K1S',
      title: 'Текущее состояние кресла',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    K2S: {
      data: 'K2S',
      title: 'K2S',
      value: null,
      type: null
    },
    k1t: {
      data: 'k1t',
      title: 'Время пребывания в текущем состоянии',
      value: null,
      type: 'interval',
      order: null,
      showOrder: true
    },
    k2t: {
      data: 'k2t',
      title: 'K2T',
      value: null,
      type: null
    },
    CTIME: {
      data: 'CTIME',
      title: 'CTIME',
      value: null,
      type: null
    },
    CLS: {
      data: 'CLS',
      title: 'CLS',
      value: null,
      type: null
    },
    HUM: {
      data: 'HUM',
      title: 'HUM',
      value: null,
      type: null
    },
    CM: {
      data: 'CM',
      title: 'CM',
      value: null,
      type: null
    },
    TBM: {
      data: 'TBM',
      title: 'Всего бонусных минут',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    RBM: {
      data: 'RBM',
      title: 'Остаток бонусных минут',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    LM: {
      data: 'LM',
      title: 'Время/дата последнего массажа',
      value: null,
      type: null,
      handler: function (data) {
        let date = data.LM
        if (date.value) date = date.value
        if (!date) return null
        let dateNew = (new Date(date)).toString()
        return `${dateNew.substring(15, 34)}`
      },
      order: null,
      showOrder: true
    },
    SS: {
      data: 'SS',
      title: 'SS',
      value: null,
      type: null
    },
    SMSTIME: {
      data: 'SMSTIME',
      title: 'SMSTIME',
      value: null,
      type: null
    },
    LC: {
      data: 'LC',
      title: 'LC',
      value: null,
      type: null
    },

    // point
    POINT_ID: {
      data: 'POINT_ID',
      title: 'ID локации',
      value: null,
      type: null
    },
    POINT_NAME: {
      data: 'POINT_NAME',
      title: 'Название локации',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    POINT_CODE: {
      data: 'POINT_CODE',
      title: 'Код',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    POINT_REGION: {
      data: 'POINT_REGION',
      title: 'Регион',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    POINT_OBLAST: {
      data: 'POINT_OBLAST',
      title: 'Область',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    POINT_GOROD: {
      data: 'POINT_GOROD',
      title: 'Город',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    POINT_ULICA: {
      data: 'POINT_ULICA',
      title: 'Улица',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    POINT_DOM: {
      data: 'POINT_DOM',
      title: 'Дом',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    POINT_INF_TYPE: {
      data: 'POINT_INF_TYPE',
      title: 'Тип локации',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    POINT_CONTACTS: {
      data: 'POINT_CONTACTS',
      title: 'Контакты',
      value: null,
      type: null
    },
    POINT_ARENDA: {
      data: 'POINT_ARENDA',
      title: 'Аренда',
      value: null,
      type: null
    },
    POINT_MODELK: {
      data: 'POINT_MODELK',
      title: 'MODELK',
      value: null,
      type: null
    },

    // dealer
    DEALER_ID: {
      data: 'DEALER_ID',
      title: 'ID дилера',
      value: null,
      type: null
    },
    DEALER_NAME: {
      data: 'DEALER_NAME',
      title: 'Название дилера',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    DEALER_IDX: {
      data: 'DEALER_IDX',
      title: 'DEALER_IDX',
      value: null,
      type: null
    },
    DEALER_REGION: {
      data: 'DEALER_REGION',
      title: 'Регион',
      value: null,
      type: null
    },
    DEALER_OBLAST: {
      data: 'DEALER_OBLAST',
      title: 'Область',
      value: null,
      type: null
    },
    DEALER_CITY: {
      data: 'DEALER_CITY',
      title: 'Город',
      value: null,
      type: null
    },
    DEALER_STREET: {
      data: 'DEALER_STREET',
      title: 'Улица',
      value: null,
      type: null
    },
    DEALER_DOM: {
      data: 'DEALER_DOM',
      title: 'Дом',
      value: null,
      type: null
    },
    DEALER_ADRES: {
      data: 'DEALER_ADRES',
      title: 'DEALER_ADRES',
      value: null,
      type: null
    },
    DEALER_NREG: {
      data: 'DEALER_NREG',
      title: 'DEALER_NREG',
      value: null,
      type: null
    },
    DEALER_INN: {
      data: 'DEALER_INN',
      title: 'ИНН',
      value: null,
      type: null
    },
    DEALER_KPP: {
      data: 'DEALER_KPP',
      title: 'КПП',
      value: null,
      type: null
    },
    DEALER_OGRN: {
      data: 'DEALER_OGRN',
      title: 'ОГРН',
      value: null,
      type: null
    },
    DEALER_OKPO: {
      data: 'DEALER_OKPO',
      title: 'ОКПО',
      value: null,
      type: null
    },
    DEALER_FIORUK: {
      data: 'DEALER_FIORUK',
      title: 'ФИО руководителя',
      value: null,
      type: null
    },
    DEALER_MOBTEL: {
      data: 'DEALER_MOBTEL',
      title: 'Мобильный телефон',
      value: null,
      type: null
    },
    DEALER_FIOBUH: {
      data: 'DEALER_FIOBUH',
      title: 'ФИО бухгалтера',
      value: null,
      type: null
    },
    DEALER_FIOMGR: {
      data: 'DEALER_FIOMGR',
      title: 'ФИО менеджера',
      value: null,
      type: null
    },
    DEALER_EMAIL: {
      data: 'DEALER_EMAIL',
      title: 'Адрес эл.почты',
      value: null,
      type: null
    },
    DEALER_ICQ: {
      data: 'DEALER_ICQ',
      title: 'ICQ',
      value: null,
      type: null
    },
    DEALER_LAST_VISIT: {
      data: 'DEALER_LAST_VISIT',
      title: 'Последний визит',
      value: null,
      type: null
    },
    DEALER_LAST_IP: {
      data: 'DEALER_LAST_IP',
      title: 'Последний IP',
      value: null,
      type: null
    },
    DEALER_DATEREG: {
      data: 'DEALER_DATEREG',
      title: 'Дата регистрации',
      value: null,
      type: null
    },
    DEALER_REGDATE: {
      data: 'DEALER_REGDATE',
      title: 'Дата регистрации',
      value: null,
      type: null
    },
    DEALER_CODE: {
      data: 'DEALER_CODE',
      title: 'Код',
      value: null,
      type: null
    },
    DEALER_isadmin: {
      data: 'DEALER_isadmin',
      title: 'Администратор',
      value: null,
      type: null
    },
    DEALER_TZ: {
      data: 'DEALER_TZ',
      title: 'DEALER_TZ',
      value: null,
      type: null
    },
    DEALER_SKYPE: {
      data: 'DEALER_SKYPE',
      title: 'Skype',
      value: null,
      type: null
    },
    DEALER_K_COUNT: {
      data: 'DEALER_K_COUNT',
      title: 'DEALER_K_COUNT',
      value: null,
      type: null
    },
    // programs
    KONTROLLER_R0: {
      data: 'KONTROLLER_R0',
      title: 'ID KONTROLLER_R0',
      value: null,
      type: null
    },
    KONTROLLER_R1: {
      data: 'KONTROLLER_R1',
      title: 'KONTROLLER_R1 локации',
      value: null,
      type: null
    },
    KONTROLLER_R2: {
      data: 'KONTROLLER_R2',
      title: 'KONTROLLER_R2',
      value: null,
      type: null
    },
    KONTROLLER_R3: {
      data: 'KONTROLLER_R3',
      title: 'KONTROLLER_R3',
      value: null,
      type: null
    },
    KONTROLLER_R4: {
      data: 'KONTROLLER_R4',
      title: 'KONTROLLER_R4',
      value: null,
      type: null
    },
    KONTROLLER_R5: {
      data: 'KONTROLLER_R5',
      title: 'KONTROLLER_R5',
      value: null,
      type: null
    },
    KONTROLLER_R6: {
      data: 'KONTROLLER_R6',
      title: 'KONTROLLER_R6',
      value: null,
      type: null
    },
    KONTROLLER_R7: {
      data: 'KONTROLLER_R7',
      title: 'KONTROLLER_R7',
      value: null,
      type: null
    },
    KONTROLLER_R8: {
      data: 'KONTROLLER_R8',
      title: 'KONTROLLER_R8',
      value: null,
      type: null
    },
    KONTROLLER_R9: {
      data: 'KONTROLLER_R9',
      title: 'KONTROLLER_R9',
      value: null,
      type: null
    },
    KONTROLLER_M0: {
      data: 'KONTROLLER_M0',
      title: 'KONTROLLER_M0',
      value: null,
      type: null
    },
    KONTROLLER_M1: {
      data: 'KONTROLLER_M1',
      title: 'KONTROLLER_M1',
      value: null,
      type: null
    },
    KONTROLLER_M2: {
      data: 'KONTROLLER_M2',
      title: 'KONTROLLER_M2',
      value: null,
      type: null
    },
    KONTROLLER_M3: {
      data: 'KONTROLLER_M3',
      title: 'KONTROLLER_M3',
      value: null,
      type: null
    },
    KONTROLLER_M4: {
      data: 'KONTROLLER_M4',
      title: 'KONTROLLER_M4',
      value: null,
      type: null
    },
    KONTROLLER_M5: {
      data: 'KONTROLLER_M5',
      title: 'KONTROLLER_M5',
      value: null,
      type: null
    },
    KONTROLLER_M6: {
      data: 'KONTROLLER_M6',
      title: 'KONTROLLER_M6',
      value: null,
      type: null
    },
    KONTROLLER_M7: {
      data: 'KONTROLLER_M7',
      title: 'KONTROLLER_M7',
      value: null,
      type: null
    },
    KONTROLLER_M8: {
      data: 'KONTROLLER_M8',
      title: 'KONTROLLER_M8',
      value: null,
      type: null
    },
    KONTROLLER_M9: {
      data: 'KONTROLLER_M9',
      title: 'KONTROLLER_M9',
      value: null,
      type: null
    },

    rating: {
      data: 'rating',
      title: 'Рейтинг',
      value: null,
      type: null,
      order: null,
      showOrder: true
    }

  }
}

function role () {
  return localStorage.getItem('role')
}

const state = {
  model: getModel(),
  id: null,
  show: 'kontrollers',
  question: getModel(),
  questions: [],
  errMain: null,
  errors: {
    m0: null,
    r0: null,
    m1: null,
    r1: null,
    m2: null,
    r2: null,
    m3: null,
    r3: null,
    m4: null,
    r4: null,
    m5: null,
    r5: null,
    m6: null,
    r6: null,
    m7: null,
    r7: null,
    m8: null,
    r8: null,
    m9: null,
    r9: null
  },
  find: [],
  finded: null,
  showFilters: false,
  // errors: {},

  filters: {
    basum: [],
    ussd: [],
    regions: [],
    oblasts: [],
    gorods: [],
    names: [],
    types: [],
    rating: []
  },
  filtersQuery: {},
  isFilter: false,

  tabs: {
    admin: {
      info: {
        data: 'info',
        title: 'Информация',
        active: true
      },
      programs: {
        data: 'programs',
        title: 'Программы',
        active: false
      },
      point: {
        data: 'point',
        title: 'Локация',
        active: false
      },
      dealer: {
        data: 'dealer',
        title: 'Дилер',
        active: false
      },
      log: {
        data: 'log',
        title: 'Лог',
        active: false
      },
      orders: {
        data: 'orders',
        title: 'Заказы',
        active: false
      }
    },
    dealer: {
      info: {
        data: 'info',
        title: 'Информация',
        active: true
      },
      programs: {
        data: 'programs',
        title: 'Программы',
        active: false
      },
      point: {
        data: 'point',
        title: 'Локация',
        active: false
      },
      log: {
        data: 'log',
        title: 'Лог',
        active: false
      },
      orders: {
        data: 'orders',
        title: 'Заказы',
        active: false
      }
    }
  }
}
const getters = {
  getModel (state) {
    return state.model
  },
  getId (state) {
    return state.id
  },
  getShow (state) {
    return state.show
  },
  getOne (state) {
    return state.question
  },
  getAll (state) {
    return state.questions
  },
  getErrors (state) {
    return state.errors
  },
  getErrMain (state) {
    return state.errMain
  },
  getFind (state) {
    return state.find
  },
  getFinded (state) {
    return state.finded
  },
  getTabs (state) {
    return state.tabs[role()]
  },
  getFilters (state) {
    return state.filters
  },
  getFiltersQuery (state) {
    return state.filtersQuery
  },
  getShowFilters (state) {
    return state.showFilters
  },
  getIsFilter (state) {
    return state.isFilter
  }
}
const mutations = {
  setModel (state, data) {
    state.model = data
  },
  setId (state, data) {
    state.id = data
  },
  setShow (state, data) {
    state.show = data
  },
  setOne (state, data) {
    state.question = data
  },
  setAll (state, data) {
    state.questions = data
  },
  setErrors (state, data) {
    state.errors[data.param] = data.value
  },
  setErrMain (state, data) {
    state.errMain = data
  },
  setFind (state, data) {
    state.find = data
  },
  setFinded (state, data) {
    state.finded = data
  },
  setTab (state, data) {
    state.tabs[role()][data.param].active = data.value
  },
  setFilters (state, data) {
    state.filters = data
  },
  setFiltersQuery (state, data) {
    state.filtersQuery = data
  },
  resetFiltersQuery (state) {
    state.filtersQuery = {}
  },
  setShowFilters (state, data) {
    state.showFilters = data
  },
  setIsFilter (state, data) {
    state.isFilter = data
  },
  setOrder (state, data) {
    for (let param in state.model) {
      if (state.model[param].order && state.model[param].showOrder && state.model[param] !== state.model[data.param]) state.model[param].order = null
    }

    let order = state.model[data.param].order
    if (!order) order = 'desc'
    else if (order === 'desc') order = 'asc'
    else if (order === 'asc') order = null
    state.model[data.param].order = order
  }
}
const actions = {
  setActiveTab ({ commit, state }, data) {
    let param = data.param
    let tabs = state.tabs[role()]
    for (let tab in tabs) {
      if (param === tab) commit('setTab', { param: tab, value: true })
      else commit('setTab', { param: tab, value: false })
    }
  },
  resetAllErr ({ state, commit }) {
    commit('setErrMain', null)
    let errors = state.errors
    if (errors) {
      for (let err in errors) {
        commit('setErrors', { param: err, value: null })
      }
    }
  },
  setModelRequired ({ commit }, data) {
    commit('setModel', mapper.modelRequired(data.required, getModel()))
  },
  sendErrMain ({ commit }, data) {
    console.log(data)
    commit('setErrMain', httpService.error(data))
  },
  toAdd ({ commit }) {
    commit('setId', null)
    commit('setShow', 'kontroller')
  },
  toUpdate ({ commit }, data) {
    commit('setId', data.id)
    commit('setShow', 'kontroller')
  },
  toAll ({ commit }) {
    commit('setId', null)
    commit('setShow', 'kontrollers')
    commit('setOne', getModel())
  },
  async getOne ({ state, commit, dispatch }, data) {
    try {
      dispatch('resetAllErr')
      if (state.id) {
        let result = await httpService.get(apiModule[role()].getOneFullMysql, { idMysql: state.id })
        commit('setOne', mapper.dataToView(data.required, getModel(), result.data.data))
      }
    } catch (err) {
      dispatch('sendErrMain', err)
    }
  },
  async getAll ({ state, commit, dispatch }, data) {
    try {
      let order = []
      let model = state.model
      for (let param in model) {
        if (model[param].order) order.push(`${model[param].data},${model[param].order}`)
      }

      data.params.order = order
      let result = await httpService.get(apiModule[role()].getAllStatusMysql, data.params)
      commit('setAll', result)
    } catch (err) {
      dispatch('sendErrMain', err)
    }
  },
  async runFind ({ state, commit, dispatch }, data) {
    try {
      commit('setFinded', null)
      let result = await httpService.get(apiModule[role()].getAllStatusMysql, data.params)
      if (!result && !result.data && !result.data.data) commit('setFind', [])
      let items = result.data.data
      let find = []
      items.forEach(item => {
        find.push(item.KID)
      })
      commit('setFind', find)
    } catch (err) {
      dispatch('sendErrMain', err)
    }
  },
  async getFilters ({ state, commit, dispatch }, data) {
    try {
      let result = await httpService.get(apiModule[role()].getFilters, data.params)
      commit('setFilters', result.data)
    } catch (err) {
      dispatch('sendErrMain', err)
    }
  },
  async updatePrograms ({ state, commit, dispatch }, data) {
    try {
      let dataMap = data.data
      let dataNew = []
      for (let i = 0; i < dataMap.length; i++) {
        let m = parseInt(dataMap[i].m)
        let r = parseInt(dataMap[i].r)
        if (!m && m !== 0) commit('setErrors', { param: `m${i}`, value: errorsStr.empty })
        if (!r && r !== 0) commit('setErrors', { param: `r${i}`, value: errorsStr.empty })
        if (m < 0 || m > 31) commit('setErrors', { param: `m${i}`, value: errorsStr.mustBeBetween0And31 })
        if (r < 0) commit('setErrors', { param: `r${i}`, value: errorsStr.lessThanZero })
        let program = {}
        program[`M${i}`] = m
        program[`R${i}`] = r
        dataNew.push(program)
      }

      let isErr = false
      for (let error in state.errors) {
        if (state.errors[error]) isErr = true
      }

      if (isErr) commit('setErrMain', errorsStr.emptyAllCorrect)
      if (!isErr) {
        let result = getModel()
        result = await httpService.patch(apiModule[role()].updatePrograms, {
          programs: dataNew,
          idMysql: state.id,
          isApplyAll: data.isApplyAll
        })
        commit('setId', result.data.data.KID)
        commit('setOne', mapper.dataToView(data.required, getModel(), result.data.data))
        dispatch('resetAllErr')
      }
    } catch (err) {
      dispatch('sendErrMain', err)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
